import { render, staticRenderFns } from "./AnamnesesLeadsTable.vue?vue&type=template&id=4a35de9f&scoped=true"
import script from "./AnamnesesLeadsTable.vue?vue&type=script&lang=js"
export * from "./AnamnesesLeadsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a35de9f",
  null
  
)

export default component.exports